// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d3a56faa","455":"8481e8f3","977":"09f36b97"}[chunkId] + ".chunk.js";
};